type Awaited<T> = T extends PromiseLike<infer U> ? U : T

export const lazyModuleMethod = <
  GM extends () => Promise<any>,
  M extends Awaited<ReturnType<GM>>,
  MN extends keyof M,
  A extends Parameters<M[MN]>,
  V extends ReturnType<M[MN]>
>(
  getModule: GM,
  method: MN
) => {
  return (async (...args: A): Promise<V> => {
    const mod = await getModule()
    return mod[method](...args)
  }) as M[MN]
}
